// 🔗 Adresse de la fiche d'un prof. Depuis le tour 60 (A3), l'adresse lisible /prof/<prénom>-<matière>-<code>,
// par exemple /prof/florian-mathematiques-a3f9c2 : code fait des 6 derniers caractères de l'identifiant de
// l'annonce, prénom et nom français de la matière sans accent, en minuscules, 40 caractères au plus chacun
// (coupés entre deux mots), « prof » sans prénom en lettres latines. Même calcul que l'API
// (acadeclic-api/app/helper/FicheProf.js, fichePath, comparé par helper/ficheServeur.test.js). L'API trouve
// l'annonce par le code seul et renvoie en 301 vers l'adresse du jour si le prénom ou la matière ont changé.
// Ancienne adresse /Teacher-Details?advert=<id> : renvoyée en 301 par l'API (liens partagés, QR codes, e-mails),
// toujours ouverte par le site (liens de l'ancien design), qui affiche ensuite l'adresse lisible.
export const TEACHER_PAGE = "/Teacher-Details";
export const PROFILE_PATH = "/prof/";

const cutSlug = (slug) => slug.replace(/^(.{40})-?.*$/, (all, head) => (all.charAt(40) === "-" || !head.includes("-") ? head : head.replace(/-[^-]*$/, "")));
export const slugOf = (text) =>
  cutSlug(
    String(text ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/œ/g, "oe")
      .replace(/æ/g, "ae")
      .replace(/ß/g, "ss")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
  ).replace(/-+$/, "");
const codeOf = (id) => String(id ?? "").slice(-6).toLowerCase();

// Adresse lisible d'une annonce : celle donnée par l'API (page_path), sinon calculée avec le prénom du prof et
// le nom de la matière (le français de préférence)
export const teacherPagePath = ({ _id, page_path, first_name, subject } = {}) =>
  page_path || `${PROFILE_PATH}${[slugOf(first_name) || "prof", slugOf(subject)].filter(Boolean).join("-")}-${codeOf(_id)}`;

// Adresse lisible demandée (« florian-mathematiques-a3f9c2 », envoyée telle quelle à l'API), null hors de /prof/
export const profileSlugOf = (pathname) => {
  const m = String(pathname || "").match(/^\/prof\/([a-z0-9-]*[0-9a-f]{6})\/?$/);
  return m ? m[1] : null;
};

// Lien vers la fiche. target : l'annonce ({ _id, page_path, first_name, subject }) pour l'adresse lisible (nouveau
// design), ou l'identifiant seul pour l'ancienne adresse (ancien design, renvoyée par l'API).
// 🧭 source : d'où vient l'élève (statistiques v2, tour 46, helper/visitSource.js), dans l'état de
// navigation, jamais dans l'adresse
export const teacherPageLocation = (target, source) => {
  const state = source ? { state: { source } } : {};
  if (target && typeof target === "object" && (target._id || target.page_path)) return { pathname: teacherPagePath(target), search: "", ...state };
  const advertId = typeof target === "object" ? null : target;
  return { pathname: TEACHER_PAGE, search: advertId ? `?advert=${encodeURIComponent(advertId)}` : "", ...state };
};
